import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import { UsersScreen } from '@/features/users/routes/users-screen'

export const Route = createFileRoute('/settings/users')({
  // ?q=<text> fills the search box — how a search result finds one person.
  validateSearch: z.object({ q: z.string().optional() }),
  component: Users,
})

function Users() {
  const { q } = Route.useSearch()
  return <UsersScreen initialQuery={q} />
}
